import { createSlice } from "@reduxjs/toolkit";
import {
  getNotifications,
  updateNotifications,
} from "../../../thunks/common-thunks/commonThunk";

const initialState = {
  isNotificationsLoading: false,
  notificationDetails: null,
  error: null,
};
export const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get User Notifications
    builder
      .addCase(getNotifications.pending, (state) => {
        state.isNotificationsLoading = true;
        state.error = null;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.isNotificationsLoading = false;
        state.notification_count = action.payload.notification_count;
        state.notifications = action.payload.notifications;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.isNotificationsLoading = false;
        state.error = action.payload;
      });

    // Updating Notifications

    builder
      .addCase(updateNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = action.payload.message;
      })
      .addCase(updateNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default notificationSlice.reducer;
